import { FC, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { SectionActive } from './SectionActive';
import { SectionPast } from './SectionPast';
import { GenericModel } from '../../../teamExperiences/models/GenericModel';
import { SectionDraft } from './SectionDraft';

interface Props {
    userId:number
}
const MyExperiencesWrapper: FC<Props> = ({ userId }) => {
    const [activeTab, setActiveTab] = useState(1)
    const history = useHistory();
    const location = useLocation();

    const tabs:Array<GenericModel> = [
        { id: 1, name: 'Active' },
        { id: 2, name: 'Past' },
        { id: 3, name: 'Draft' },
    ]

    const changeTab = async (status: number) => {
        setActiveTab(status);
    }

    const setParam = (key:string, value:string) => {
        const params = new URLSearchParams(location.search);
        params.set(key, value);

        history.push({
            pathname: location.pathname,
            search: params.toString(),
        });
    };

    const renderContentOptionSelected = () => {
        switch (activeTab) {
            case 1:
                return (<SectionActive userId={userId} />);
            case 2:
                return (<SectionPast userId={userId} />);
            case 3:
                return (<SectionDraft userId={userId} />);
            default:
                return null;
        }
    }

    return (
        <div className="tap-host-wrapper">
            <div className="tap-host-container gap-5 mt-5">
                <div className="tap-host-section">
                    <div className="card">
                        <div className="tap-add-experience-2-radio-row">
                            {tabs.map((item:any,index:number)=>(<div key={`experience-my-profile-${index}`} className={`tap-add-experience-2-radio-card h-fit w-50 ${item.id === activeTab ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                                <label className="tap-host-option p-6 pt-3 pb-3 w-100">
                                    <input type="radio" className="tap-host-radio-input"
                                        name="host_type"
                                        value="partner"
                                        checked={item.id == activeTab}
                                        onChange={()=>changeTab(item.id)}
                                    />
                                    <div className="tap-host-radio">
                                        <div className="tap-host-radio-outer"></div>
                                        <div className="tap-host-radio-inner"></div>
                                    </div>
                                    <div className="tap-host-option-label">{item.name}</div>
                                </label>
                            </div>))}
                        </div>
                    </div>
                </div>
                <div className="tap-host-footer">
                    {renderContentOptionSelected()}
                </div>
            </div>
        </div>

    )
}

export { MyExperiencesWrapper }
